import { number } from 'prop-types';
import React from 'react';

import CurrencyFormat from '../CurrencyFormat';

const SUFFIXES = ['k'];

function shorten(value) {
  if (value === 0) return { value };
  const log10 = Math.log10(Math.abs(value));
  const magnitude = Math.min(SUFFIXES.length, Math.floor(log10 / 3));
  const shortValue = Math.round(value / 10 ** (magnitude * 3));
  const suffix = SUFFIXES[magnitude - 1];
  return { value: shortValue, suffix };
}

function ShortCurrencyFormat({ value: rawValue, ...rest }) {
  const { value, suffix } = shorten(rawValue);
  return <CurrencyFormat value={value} suffix={suffix} text {...rest} />;
}

ShortCurrencyFormat.propTypes = {
  value: number,
};

ShortCurrencyFormat.defaultProps = {
  value: undefined,
};

export default ShortCurrencyFormat;
